import React, { useState, useEffect } from "react";
import "./App.css"; // Import your CSS file
import blacklogo from "./img/logoblack.png";
import back from "./img/back.svg";
import download from "./img/download.png";
import guide from "./img/download-pdf.png";
import Loader from "./Loader"; // Import the Loader component

function App() {
  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch("https://learn.elehome.ir/panel/api.php");
        const result = await response.json();
        setData(result);

        const urlParams = new URLSearchParams(window.location.search);
        let fileName = urlParams.get("file");

        if (fileName && result.find((item) => item.file === fileName)) {
          setSelectedItem(result.find((item) => item.file === fileName));
          setShowGrid(false);

          window.history.pushState(null, null, `?file=${fileName}`);
        }

        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleItemClick = (item) => {
    setSelectedItem(item);
    setShowGrid(false);

    window.history.pushState(null, null, `?file=${item.file}`);
  };

  const handleCloseDetail = () => {
    setSelectedItem(null);
    setShowGrid(true);

    window.history.back();
  };

  const getDownloadLink = (fileName) => {
    return `https://learn.elehome.ir/panel/pdf/${fileName}`;
  };

  return (
    <div className="App">
      <Loader />
      <div className="screen">
        <div className="container">
          <div className="header">
            <div className="detail-view-header">
              <img src={blacklogo} width="20px" height="20px" alt="Logo" />
              <h3>فایل های راهنما</h3>
            </div>
            <div className="detail-view-header-back">
              <img
                onClick={handleCloseDetail}
                src={back}
                width="30px"
                alt="Back"
              />
            </div>
          </div>
          {isLoading ? (
            <div>Loading...</div>
          ) : (
            <>
              {showGrid && (
                <div className="grid-container">
                  {data.map((item, index) => (
                    <div
                      key={index}
                      className="grid-item"
                      onClick={() => handleItemClick(item)}
                    >
                      <img
                        className="gridImg"
                        src={`https://learn.elehome.ir/panel/img/${item.imageUrl}`}
                        alt={item.name}
                      />
                      <div>
                        <h4>{item.name}</h4>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              {selectedItem && (
                <div className="detail-view">
                  <div className="detail-view-body">
                    <div className="detail-view-body-inner">
                      <div className="item-image">
                        <img
                          src={`https://learn.elehome.ir/panel/img/${selectedItem.imageUrl}`}
                          alt={selectedItem.name}
                        />
                      </div>
                      <div className="item-desc">
                        <h2>{selectedItem.name}</h2>
                        <span
                          style={{
                            fontSize: "20px",
                            fontWeight: "normal",
                            lineHeight: "40px",
                          }}
                        >
                          {selectedItem.description}
                        </span>
                        <div className="dataList">
                          <div className="brandDiv">
                            <p>برند:</p>
                            <a
                              href={selectedItem.brandwebsite}
                              target="_blank"
                              className="linkGeneral"
                              rel="noopener noreferrer"
                            >
                              <span className="brandClass">
                                {selectedItem.brand}
                              </span>
                            </a>
                          </div>
                          <div>|</div>
                          <div className="brandDiv">
                            <p style={{ margin: "0px" }}>دسته بندی:</p>
                            <span className="">{selectedItem.category}</span>
                          </div>
                        </div>
                        <div className="dataList">
                          <div className="brandDiv" style={{background:'#aef3f5',padding:'10px',borderRadius:'10px'}}>
                            <a 
                              href="https://app.elehome.ir"
                              style={{ margin: "0px",textDecoration:'none',Color:'black',fontWeight:'bold' }}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              دانلود اپلیکیشن اندروید / IOS
                            </a>
                          </div>
                        </div>

                        <div className="dataList">
                          <div className="brandDiv" style={{flexDirection:'column',textAlign:'right',alignItems:'start'}}>
                             <span style={{marginBottom:'-30px',fontWeight:'bold',marginTop:'20px'}}>راهنمای سریع</span>
                            <ul>
                            <li>ثبت نام از طریق شماره موبایل</li>
                            <li>کلیک روی گزینه +</li>
                            <li>انتخاب دستگاه از طریق برند</li>
                            <li>ادامه بر اساس راهنمای گرافیکی</li>
                            <li>دستگاه آماده استفاده است</li>
                            </ul>
                          </div>
                        </div>

                        <div className="detail-view-body-link">
                          <div className="linkDiv">
                            <a
                              href="https://learn.elehome.ir/panel/pdf/Elehome_iot_v01%20(2).pdf"
                              target="_blank"
                              className="linkGeneral"
                              rel="noopener noreferrer"
                            >
                              دانلود راهنمای عمومی
                            </a>
                            <img src={guide} width="50px" alt="Guide" />
                          </div>
                          <div className="linkDiv">
                            <a
                              href={getDownloadLink(selectedItem.file)}
                              target="_blank"
                              className="linkGeneral"
                              rel="noopener noreferrer"
                            >
                              دانلود نسخه PDF
                            </a>
                            <img src={download} width="50px" alt="Download" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="configDiv">
                    <div className="smartconfig">
                      <div className="configDiv-header">
                        <h4>راهنما</h4>
                      </div>
                      <div className="configDiv-body">
                        <div className="configImage">
                          <video
                            autoPlay
                            loop
                            muted
                            style={{ maxWidth: "100%" }}
                          >
                            <source
                              src={`https://learn.elehome.ir/panel/config_files/${selectedItem.config_file}`}
                              type="video/mp4" // Update this with the appropriate MIME type if needed
                            />
                            Your browser does not support the video tag.
                          </video>{" "}
                        </div>
                        <div className="configText">
                          <span className="">{selectedItem.config}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
